import * as React from 'react';
import { getId } from 'office-ui-fabric-react/lib/Utilities';

import {
  getTheme,
  mergeStyleSets,
  FontWeights,
  ContextualMenu,
  //Checkbox,
  //DefaultButton,
  Modal,
  IDragOptions,
  IconButton
} from 'office-ui-fabric-react';


import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { FontSizes } from '@uifabric/styling';
import  './planner.scss';
export interface IProps {
    closeMethod;
    setTasklink;
    phrases;
  }

const theme = getTheme();
const contentStyles = mergeStyleSets({
  container: {
    display: 'flex',
    flexFlow: 'column nowrap',
    alignItems: 'stretch'
  },
  header: [
    // tslint:disable-next-line:deprecation
    theme.fonts['xLargePlus'],
    {
      flex: '1 1 auto',
      borderTop: `4px solid ${theme.palette.themePrimary}`,
      color: theme.palette.neutralPrimary,
      display: 'flex',
      fontSize: FontSizes.xLarge,
      alignItems: 'center',
      fontWeight: FontWeights.semibold,
      padding: '12px 12px 14px 24px'
    }
  ],
  body: {
    flex: '4 4 auto',
    padding: '0 24px 24px 24px',
    overflowY: 'hidden',
    selectors: {
      p: {
        margin: '14px 0'
      },
      'p:first-child': {
        marginTop: 0
      },
      'p:last-child': {
        marginBottom: 0
      }
    }
  }
});

const iconButtonStyles = mergeStyleSets({
  root: {
    color: theme.palette.neutralPrimary,
    marginLeft: 'auto',
    marginTop: '4px',
    marginRight: '2px'
  },
  rootHovered: {
    color: theme.palette.neutralDark
  }
});
export default class NewTaskLink extends React.Component<IProps> {  
    private _titleId: string = getId('title');
    private _subtitleId: string = getId('subText');
    private _dragOptions: IDragOptions = {
                                            moveMenuItemText: 'Move',
                                            closeMenuItemText: 'Close',
                                            menu: ContextualMenu
                                        };
    private Linkvalue='';
    private linkAlise='';
    private FromValidationMessages=[];
    constructor(props) {
        super(props);      
        }
    public render() {
   
    return (
            <div>         
              <Modal
                titleAriaId={this._titleId}
                subtitleAriaId={this._subtitleId}
                isOpen={true}
                onDismiss={()=>{this.props.closeMethod(false)}}
                isBlocking={true}
                containerClassName={contentStyles.container}
                dragOptions={this._dragOptions}
              >
              <div className={contentStyles.header}>
              <span id={this._titleId}>{this.props.phrases.addnewlink}</span>
             
              <IconButton
                styles={iconButtonStyles}
                iconProps={{ iconName: 'Cancel' }}
                ariaLabel="Close popup modal"
                onClick={()=>{this.props.closeMethod(false)}}
              />
              </div>
              
              <div id={this._subtitleId} className={contentStyles.body}>
              <div className="ms-Grid-row">                  
                  <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg6">
                    <TextField 
                        onChange={(event)=>{
                            this.Linkvalue=event.target["value"];
                        }}  
                        label={this.props.phrases.addresscaption+' *'} 
                        placeholder={this.props.phrases.addressplaceholder} 
                    />                        
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg6">
                    <TextField 
                        onChange={(event)=>{
                            this.linkAlise=event.target["value"];
                        }}  
                        label={this.props.phrases.linkalisecaption}
                        placeholder={this.props.phrases.linkaliseplaceholder} />                        
                  </div>
              </div>
              
              <div className="ms-Grid-row">
                 <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 notebox">
                   <ul className="error">
                     {this.FromValidationMessages}
                   </ul>
                   
                 </div>
              </div>
              <div className="ms-Grid-row">
                  <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                      <div className="buttonarea">
                      <button onClick={this.SetLinkValue} className="ms-Button ms-Button--default viewswitchbtn plannertask">
                        {this.props.phrases.save}
                      </button>
                      <button 
                        className="ms-Button ms-Button--default viewswitchbtn"
                        onClick={()=>{this.props.closeMethod(false)}}
                      >
                        {this.props.phrases.cancel}
                      </button>
                      </div>
                    
                  </div>
              </div>
              </div>
              </Modal>
            </div>
            );
  }
  private SetLinkValue=()=>{
    this.FromValidationMessages=[];
    this.linkAlise=this.linkAlise.trim();
    this.Linkvalue=this.Linkvalue.trim(); 
    if(this.Linkvalue==''){
        this.FromValidationMessages.push(<li>{this.props.phrases.linkvalidationreq}</li>);
    }
    else if(!this.isValidUrl(this.Linkvalue)){
      this.FromValidationMessages.push(<li>{this.props.phrases.linkvalidationvalid}</li>);
    }
    if(this.linkAlise==''){
      this.FromValidationMessages.push(<li>{this.props.phrases.linkalisevalidationreq}</li>);
    }
    if(this.FromValidationMessages.length>0){
        return this.setState({changed:true});
    }
    let lnk =this.Linkvalue.replace(':', '%3A');
    lnk = lnk.replace(/\./g, '%2E');
    let newValue={
          prop:lnk,
          refval:{
            "@odata.type": "microsoft.graph.plannerExternalReference",
            "alias": this.linkAlise,
            "previewPriority": "  !!"
        }
      };
    this.props.setTasklink(newValue);
  }
  private isValidUrl = (string) => {
    try {
      new URL(string);
      return true;
    } catch (ex) {
      return false;  
    }
  }
}
